// @flow

import React from 'react'
import Appear from './Appear'
import { markdown } from 'markdown'

type Props = {
  text: string,
}

const Communications2 = ({ text }: Props) => {
  
  const getNumber = text.split(".")[0]

  return (
    <Appear>
      <div className="flex items-start justify-start mb-4">
        <span className="mr-4 text-base font-bold md:text-lg text-green">{getNumber}.</span>
        {text && <div className="text-base font-light text-left break-words md:text-lg" dangerouslySetInnerHTML={{ __html: markdown.toHTML(text) }} />}
      </div>
    </Appear>
  )
}

export default Communications2
